module.exports = __webpack_public_path__ + "img/index-banner-logo.076ed67a.png";